import React, { useState } from "react";
import {
  Form,
  Input,
  Select,
  Row,
  Col,
  Typography,
  Modal,
  Button,
  message,
} from "antd";
import AppConfig from "../../config/AppConfig";
import { verifyName } from "../../../Api/Apis";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom"

const { Text } = Typography;

const Section1 = ({
  formValues,
  setFormValues,
  validationErrors = {},
  setValidationErrors = () => {},
  onLogin,
}) => {
  const [visible, setVisible] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);
  const signedIn = !!formValues.signedInExisting;

  const showModal = () => setVisible(true);
  const hideModal = () => setVisible(false);

  const handleSignin = async (e) => {
    e?.preventDefault();
    if (!username || !password) {
      message.warning("Please enter username and password.");
      return;
    }
    try {
      setLoggingIn(true);
      const ok = await onLogin(username, password);
      if (ok) {
        setVisible(false);
        // optional: clear inputs
        setUsername("");
        setPassword("");
      }
    } finally {
      setLoggingIn(false);
    }
  };

  const handleVerify = async () => {
    const name = (formValues.businessName || "").trim();
    if (!name) return alert("Please enter your Agency Name to verify.");
    try {
      const res = await verifyName(AppConfig.entityNames.registrations, {
        businessName: name,
      });
      if (res?.data?.statusCode === 0) {
        alert(res.data.message || "Business found.");
      } else {
        alert("Business name doesn't exist, please sign up.");
      }
    } catch (e) {
      console.error(e);
      alert("Could not verify business name.");
    }
  };

  const handleChange = (key, value) => {
    setFormValues((prev) => {
      const next = { ...prev, [key]: value };

      // mirror state fields so payload can use either
      if (key === "stateName") next.state = value;
      if (key === "state") next.stateName = value;

      // if (key === "businessName") next.businessName = value;
      // if (key === "agencyName") next.businessName = value;

      // optional: if user fills city and state is empty, default to CT
      if (key === "city" && !prev.stateName) {
        next.stateName = "Connecticut";
        next.state = "Connecticut";
      }
      return next;
    });

    if (value) setValidationErrors((prev) => ({ ...prev, [key]: "" }));
  };

  return (
    <>
      {!signedIn && (
        <Row>
          <Col
            span={24}
            style={{
              textAlign: "center",
              marginLeft: "-3%",
              marginBottom: "20px",
            }}
          >
            <h3>
              If your business is already registered with us, please{" "}
              <a
                href="/#"
                onClick={(e) => {
                  e.preventDefault();
                  showModal();
                }}
                style={{ color: "#000000", padding: "5px" }}
              >
                <b>click here</b>
              </a>{" "}
              to sign in.
            </h3>
          </Col>
        </Row>
      )}

      <Form layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="1. Agency Name"
              required
              validateStatus={validationErrors.businessName ? "error" : ""}
              help={validationErrors.businessName}
            >
              <Input
                type="text"
                placeholder="Enter Agency Name"
                value={formValues.businessName || ""}
                onChange={(e) => handleChange("businessName", e.target.value)}
                style={{ borderRadius: "30px" }}
              />
              <span
                onClick={handleVerify}
                style={{
                  color: "#165874",
                  cursor: "pointer",
                  padding: "10px",
                }}
              >
                <b> Verify</b>
              </span>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="2. Contact Name"
              required
              validateStatus={validationErrors.contactName ? "error" : ""}
              help={validationErrors.contactName}
            >
              <Input
                type="text"
                placeholder="Full name of the primary contact"
                value={formValues.contactName || ""}
                onChange={(e) => handleChange("contactName", e.target.value)}
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="3. Title"
              required
              validateStatus={validationErrors.title ? "error" : ""}
              help={validationErrors.title}
            >
              <Input
                placeholder="e.g., Owner, Marketing Director"
                value={formValues.title || ""}
                onChange={(e) => handleChange("title", e.target.value)}
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="4. Email"
              required
              validateStatus={validationErrors.email ? "error" : ""}
              help={validationErrors.email}
            >
              <Input
                type="email"
                placeholder="example@agency.com"
                value={formValues.email || ""}
                onChange={(e) => handleChange("email", e.target.value)}
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              label="5. Phone Number"
              required
              validateStatus={validationErrors.phoneNumber ? "error" : ""}
              help={validationErrors.phoneNumber}
            >
              <NumberFormat
                className="input_width"
                format="+1 (###) ###-####"
                value={formValues.phoneNumber || ""}
                style={{
                  borderRadius: "30px",
                  // width: "400px",
                  height: "40px",
                  padding: "10px",
                  border: "1px solid rgba(0, 0, 0, 0.1)",
                }}
                onChange={(e) => handleChange("phoneNumber", e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label={
                <>
                  6. Address{" "}
                  <Text type="secondary" style={{ fontSize: 12 }}>
                    *We are currently serving businesses only in Connecticut
                  </Text>
                </>
              }
              required
              validateStatus={validationErrors.address ? "error" : ""}
              help={validationErrors.address}
            >
              <Input
                placeholder="Street Address"
                value={formValues.address || ""}
                onChange={(e) => handleChange("address", e.target.value)}
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="City"
              required
              validateStatus={validationErrors.city ? "error" : ""}
              help={validationErrors.city}
            >
              <Input
                placeholder="City"
                value={formValues.city || ""}
                onChange={(e) => handleChange("city", e.target.value)}
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="State"
              required
              validateStatus={validationErrors.stateName ? "error" : ""}
              help={validationErrors.stateName}
            >
              <Input
                placeholder="Enter State"
                value={formValues.stateName || ""}
                onChange={(e) => handleChange("stateName", e.target.value)}
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Zip Code"
              required
              validateStatus={validationErrors.zip ? "error" : ""}
              help={validationErrors.zip}
            >
              <Input
                placeholder="ZIP Code"
                value={formValues.zip || ""}
                onChange={(e) => handleChange("zip", e.target.value)}
                style={{ borderRadius: "30px" }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label="7. What is your business entity type?"
          required
          validateStatus={validationErrors.businessEntityType ? "error" : ""}
          help={validationErrors.businessEntityType}
        >
          <Select
            placeholder="Select entity type"
            value={formValues.businessEntityType}
            onChange={(val) => handleChange("businessEntityType", val)}
          >
            <Select.Option value="Sole Proprietor">
              Sole Proprietor
            </Select.Option>
            <Select.Option value="LLC">LLC</Select.Option>
            <Select.Option value="Corporation">
              Corporation (C or S)
            </Select.Option>
            <Select.Option value="Nonprofit">Nonprofit</Select.Option>
            <Select.Option value="Government / Public Agency">
              Government / Public Agency
            </Select.Option>
            <Select.Option value="Political Organization">
              Political Organization
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="8. Is your business registered as a vendor with the State of Connecticut’s Supplier Registration?"
          required
          validateStatus={validationErrors.vendorRegistration ? "error" : ""}
          help={validationErrors.vendorRegistration}
        >
          <Select
            placeholder="Select status"
            value={formValues.vendorRegistration}
            onChange={(val) => handleChange("vendorRegistration", val)}
          >
            <Select.Option value="Yes">Yes</Select.Option>
            <Select.Option value="No">No</Select.Option>
            <Select.Option value="In progress">In progress</Select.Option>
            <Select.Option value="Not applicable">Not applicable</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="9. Is your business certified as a Small or Minority Business Enterprise (S/MBE) in Connecticut?"
          required
          validateStatus={validationErrors.smbCertification ? "error" : ""}
          help={validationErrors.smbCertification}
        >
          <Select
            placeholder="Select certification status"
            value={formValues.smbCertification}
            onChange={(val) => handleChange("smbCertification", val)}
          >
            <Select.Option value="Yes">Yes</Select.Option>
            <Select.Option value="No">No</Select.Option>
            <Select.Option value="In progress">In progress</Select.Option>
            <Select.Option value="Not applicable">Not applicable</Select.Option>
          </Select>
        </Form.Item>
      </Form>
      {visible && (
        <Modal
          title="SIGN-IN"
          visible={visible}
          onCancel={hideModal}
          destroyOnClose
          footer={
            <div>             
              <Button type="primary" onClick={handleSignin} loading={loggingIn}>
                Log in
              </Button>
            </div>
          }
        >
          <Form layout="vertical">
            <Form.Item label="Email Address :">
              <Input
                className="input_modal"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Password">
              <Input.Password
                className="input_password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Item>
            <Link to={{
              pathname: "/app/ForgotPassword",
              search: "?profileType=registrations",
              state: { fromHeader: true },
            }}
              onClick={() => {
                setVisible(false);
                sessionStorage.setItem("backSrc", "header");
              }}
              style={{
                  color: "rgb(22, 88, 116)",
                  fontWeight: "bold",
                  cursor: "pointer",
                  display:'flex',
                  justifyContent:'flex-end'
                }}
              >
            Forgot Password? click here to change it
            </Link>
          </Form>
        </Modal>
      )}
    </>
  );
};

// Validation function
Section1.validate = (formValues) => {
  const errors = {};

  const requiredFields = [
    "businessName",
    "contactName",
    "title",
    "email",
    "phoneNumber",
    "address",
    "city",
    "stateName",
    "zip",
    "businessEntityType",
    "vendorRegistration",
    "smbCertification",
  ];

  requiredFields.forEach((field) => {
    if (!formValues[field]) {
      errors[field] = "This field is required";
    }
  });

  return errors;
};

export default Section1;
